// ForgetPasswordPage.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgetPasswordStyle.css"

const ForgetPasswordPage: React.FC = () => {
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState("")
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

    const onButtonClick = () => {
        // Set initial error values to empty
        setEmailError("")

        // Check if the user has entered both fields correctly
        if ("" === email) {
            setEmailError("Bitte E-Mail Adresse eingeben")
            return
        }

        handleLogin(email);
    }

    const onButtonSendClick = () => {
        setShowPopup(false)
        navigate("/Login")
    }

    const handleLogin = async (mail:string) => {
        try {
          const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/SendNewPassword.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              mail,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            //console.log('Erfolgreich eingeloggt:', data);
            //console.log('tag:', data['tag']);
            const mailStatus = data['message'];
            if(mailStatus != "E-Mail not exist"){
                setShowPopup(true);
            } else{
                navigate("/Login")
            }
            
          } else {
            const data = await response.json();
            console.log(data);
            console.error('Fehler beim Einloggen:', response.statusText);
          }
        } catch (error) {
          console.error('Fehler beim Einloggen:', error);
        }
      };

    return <div className="mainContainer">
    <div className="titleContainer">
        <h2>Junior Alarm Passwort vergessen</h2>
    </div>
    <br />
    <div className="inputContainer">
        <input
            value={email}
            placeholder="E-Mail Adresse"
            onChange={ev => setEmail(ev.target.value)}
            className="inputBox" />
        <label className="errorLabel">{emailError}</label>
    </div>
    <br></br>
    <div className="inputContainer">
        <input
            className="inputButton"
            type="button"
            onClick={onButtonClick}
            value={"Neues Passwort senden"} />
    </div>


    {showPopup && ( // Pop-up Bedingung
                <div className="popup">
                    <div className="popupContent">
                        <p>Passwort wurde an die angegebene Mail-Adresse gesendet.</p>
                        <div className="inputContainer">
                            <input
                                className="inputButton"
                                type="button"
                                onClick={onButtonSendClick}
                                value={"Schließen"} />
                        </div>
                    </div>
                </div>
    )}
</div>
}

export default ForgetPasswordPage;